<div class="change-page-confirm-content">
    <div class="width-100 d-flex justify-content-center pt-2 pb-2">
        <img src="assets/icons/warning_dialog.svg" alt="warning">
    </div>
    <div>
        <p class="title-size-1 color-black text-center">{{ data.title }}</p>
        <p class="text-size-2 color-black text-center">
            {{ data.message }}
        </p>
        <p class="color-black text-center font-omicron-bold">
            {{ data.extraQuestion }}
        </p>
    </div>
    <div class="change-page-confirm-actions">
        <button mat-stroked-button class="font-size-button white-button"
            autofocus="false" color="primary" (click)="close(true)">
            {{ data.closeTrueButton }}
        </button>
        <button mat-raised-button class="font-size-button blue-button margin-button" color="primary" (click)="close(false)">
            {{ data.closeFalseButton }}
        </button>
    </div>
</div>